module.exports = __webpack_public_path__ + "img/audit_reject.f8d1caf1.png";